import apiClient from '../../api/client';

/** Fetch the stock-import template (XLSX, the previous system's stock-export layout) and save it. */
export async function downloadStockTemplate(): Promise<void> {
  const { data } = await apiClient.get<Blob>('/purchasing/stock-import/template', {
    responseType: 'blob',
  });
  const url = URL.createObjectURL(data);
  const a = document.createElement('a');
  a.href = url;
  a.download = 'modele-import-stock.xlsx';
  a.click();
  URL.revokeObjectURL(url);
}
